import axios from "axios"
import config from './src/api/env.js';
import Vue from 'vue'
import Element from 'element-ui'
Vue.use(Element)

var request=axios.create({
	baseURL:config.baseURL
})

// 响应拦截器
request.interceptors.response.use((res)=>{


            if(res.data.result == 'error'){
                Element.Notification({
                    title: '警告',
                    message: res.data.msg || '后台错误',
                    type: 'warning'
                });
                return 
            }else if(res.data.status == 200){
                return res.data;
            }
     
	
},(error)=>{
  
    if(error){
        Element.Notification({
            title: '警告',
            message: '后台错误',
            type: 'warning'
        });
      }
	return Promise.reject(error)
})
// 请求拦截器
request.interceptors.request.use(
    config => {
        if (window.localStorage.getItem('fduId')) {
            config.headers.common['fduid'] = window.localStorage.getItem('fduId');
        } else {
            //console.log(config);
        }
       
        return config;
    },
    error => {
        return Promise.reject(error);
    }
);

export default request
